<template>
  <div>
    <v-row>
      <v-col
        cols="12"
        :md="!view?12:6"
      >
        <base-material-card icon="mdi-account-outline">
          <template v-slot:after-heading>
            <div class="title font-weight-light">
              <span class="body-1">Страховой полис - </span>
              <v-spacer />
              <span class="body-2">{{ title }}
                <v-icon
                  v-if="view && form.id!=null"
                  @click="view = false, change = true"
                >mdi-pencil</v-icon>
                <v-icon
                  v-if="change && form.id!=null"
                  @click="view = true, change= false"
                >mdi-eye</v-icon>
              </span>
            </div>
          </template>

          <form>
            <base-material-tabs
              v-model="tab"
              color="warning"
            >
              <v-tab>Страховая</v-tab>
              <v-tab>Объект страхования</v-tab>
              <v-tab>Страхователь</v-tab>
              <v-tab>Собственник</v-tab>
              <v-tab>Водитель</v-tab>
              <v-tab-item>
                <v-row>
                  <v-col cols="6">
                    <v-select  :disabled="view" v-model="form.state" :items="select.unsurance_state" label="Статус"/>
                  </v-col>
                  <v-col cols="3">
                    <v-text-field v-model="form.sum"  v-if="form.state == 1" label="Сумма страхования" type="number"/>
                  </v-col>
                  <v-col cols="3">
                    <v-text-field v-model="form.revenue"  v-if="form.state == 1 && ( ($store.state.user.role != 3 && $store.state.user.role != 2) || create)" label="Сумма вознаграждения" type="number"/>
                  </v-col>
                  <v-col cols="8">
                    <v-select
                      v-model="form.insurer"
                      :items="select.insurer"
                      color="secondary"
                      label="Страховая"
                      :disabled="view"
                      clearable
                    />
                  </v-col>
                  <v-col cols="4">
                    <v-checkbox
                      v-model="form.eurocom"
                      label="ЕВРОКОМ"
                      @change="eurocom"
                      />
                  </v-col>
                  <v-col cols="12">
                    <v-autocomplete
                      v-model="form.product"
                      :items="select.insurance_product.filter(a=>!form.insurer || form.insurer == a.insurer.value)"
                      color="secondary"
                      label="Страховой продукт"
                      :disabled="view"
                      :filter="insurance_product_filter"
                      @change="product_change"
                    >
                      <template v-slot:selection="{item}">
                        <v-col cols="12">
                          <font :color="item.color">{{item.text}}</font>
                        </v-col>
                      </template>
                      <template v-slot:item="{item}">
                        <v-row dense class="ma-5">
                          <v-col cols="12">
                            <font :color="item.color">{{item.text}}</font>
                          </v-col>
                          <v-col cols="12">
                            <font v-if="item.insurer.name" color="black">{{item.insurer.name}}</font>
                          </v-col>
                        </v-row>
                      </template>
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-checkbox
                      label="Проведение техосмотра"
                      v-model="form.to"
                    />
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field
                      v-if="form.to"
                      label="Сумма вонаграждения по ТО"
                      v-model="form.sum_to"
                      type="number"
                    />
                  </v-col>
                  <v-col cols="6">
                  </v-col>
                  <v-col
                    cols="12"
                    md="4"
                  >
                    <v-text-field
                      v-model="form.doc.series"
                      color="secondary"
                      label="Серия"
                      :rules="[(v) => !!v || 'Заполните поле',(v) => /^.{3}$/.test(v) || 'Неверное значение']"
                      prepend-icon="mdi-car"
                      :counter="3"
                      maxlength="3"
                      :disabled="view"
                      @input="()=>{form.doc.series = form.doc.series.toUpperCase().substring(0,3),check_insurance_existance(form, (data) => {
                                  form = data
                                },
                                ()=>{
                                  form.create_new = true
                                })}"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="8"
                  >
                    <v-text-field
                      v-model="form.doc.number"
                      color="secondary"
                      label="Номер полиса"
                      :rules="[(v) => !!v || 'Заполните поле',(v) => /^.{10}$/.test(v) || 'Неверное значение']"
                      :counter="10"
                      maxlength="10"
                      :disabled="view"
                      @input="()=>{form.doc.number = form.doc.number.toUpperCase().substring(0,10),check_insurance_existance(form, (data) => {
                                  form = data
                                },
                                ()=>{
                                  form.create_new = true
                                })}"
                    />
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      v-model="form.doc.from_date"
                      color="secondary"
                      type="date"
                      label="Начало действия"
                      prepend-icon="mdi-car"
                      :disabled="view"
                    />
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      v-model="form.doc.date"
                      color="secondary"
                      type="date"
                      label="Срок действия"
                      prepend-icon="mdi-car"
                      :disabled="view"
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="form.comment"
                      label="Комментарий"
                      :disabled="view"
                      />
                  </v-col>
                </v-row>
                <v-row v-for="(extra_insurance, index) in extra" :key="'extra_' + index" v-if="create">
                  <v-col cols="6">
                    <v-select  :disabled="view" v-model="extra_insurance.state" :items="select.unsurance_state" label="Статус"/>
                  </v-col>
                  <v-col cols="3">
                    <v-text-field v-model="extra_insurance.sum"  v-if="extra_insurance.state == 1" label="Сумма страхования" type="number"/>
                  </v-col>
                  <v-col cols="3">
                    <v-text-field v-model="extra_insurance.revenue"  v-if="extra_insurance.state == 1" label="Сумма вознаграждения" type="number"/>
                  </v-col>
                  <v-col cols="8">
                    <v-select
                      v-model="extra_insurance.insurer"
                      :items="select.insurer"
                      color="secondary"
                      label="Страховая"
                      :disabled="view"
                      clearable
                    />
                  </v-col>
                  <v-col cols="4">
                    <v-checkbox
                      v-model="extra_insurance.eurocom"
                      label="ЕВРОКОМ"
                      @change="eurocom"
                      />
                  </v-col>
                  <v-col cols="12">
                    <v-autocomplete
                      v-model="extra_insurance.product"
                      :items="select.insurance_product.filter(a=>!extra_insurance.insurer || extra_insurance.insurer == a.insurer.value)"
                      color="secondary"
                      label="Страховой продукт"
                      :disabled="view"
                      :filter="insurance_product_filter"
                      @change="extra_insurance.insurer = get_insurer(extra_insurance.product)"
                    >
                      <template v-slot:selection="{item}">
                        <v-col cols="12">
                          <font :color="item.color">{{item.text}}</font>
                        </v-col>
                      </template>
                      <template v-slot:item="{item}">
                        <v-row dense class="ma-5">
                          <v-col cols="12">
                            <font :color="item.color">{{item.text}}</font>
                          </v-col>
                          <v-col cols="12">
                            <font v-if="item.insurer.name" color="black">{{item.insurer.name}}</font>
                          </v-col>
                        </v-row>
                      </template>
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-checkbox
                      label="Проведение техосмотра"
                      v-model="extra_insurance.to"
                    />
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field
                      v-if="extra_insurance.to"
                      label="Сумма вонаграждения по ТО"
                      v-model="extra_insurance.sum_to"
                      type="number"
                    />
                  </v-col>
                  <v-col cols="6" class="text-right">
                    <v-icon @click="extra = extra.filter(a=>a!=extra_insurance)">mdi-delete</v-icon>
                  </v-col>
                  <v-col
                    cols="12"
                    md="4"
                  >
                    <v-text-field
                      v-model="extra_insurance.doc.series"
                      color="secondary"
                      label="Серия"
                      prepend-icon="mdi-car"
                      :disabled="view"
                      @input="()=>{extra_insurance.doc.series = extra_insurance.doc.series.toUpperCase().substring(0,3),check_insurance_existance(extra_insurance, (data) => {
                                  extra_insurance = data
                                },
                                ()=>{
                                  extra_insurance.create_new = true
                                })}"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="8"
                  >
                    <v-text-field
                      v-model="extra_insurance.doc.number"
                      color="secondary"
                      label="Номер полиса"
                      :disabled="view"
                      @input="()=>{extra_insurance.doc.number = extra_insurance.doc.number.toUpperCase().substring(0,10),check_insurance_existance(extra_insurance, (data) => {
                                  extra_insurance = data
                                },
                                ()=>{
                                  extra_insurance.create_new = true
                                })}"
                    />
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      v-model="extra_insurance.doc.from_date"
                      color="secondary"
                      type="date"
                      label="Начало действия"
                      prepend-icon="mdi-car"
                      :disabled="view"
                    />
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      v-model="extra_insurance.doc.date"
                      color="secondary"
                      type="date"
                      label="Срок действия"
                      prepend-icon="mdi-car"
                      :disabled="view"
                    />
                  </v-col>
                  <v-col cols="4">
                    <v-checkbox
                      v-model="extra_insurance.kasko"
                      color="secondary"
                      label="КАСКО"
                      :disabled="view"
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="extra_insurance.comment"
                      label="Комментарий"
                      :disabled="view"
                      />
                  </v-col>
                </v-row>
                <v-row v-if="create">
                  <v-col cols="12">
                    <div class="add-new-research" @click="extra.push({ doc: {}})">
                      <v-img src="/add-file.svg" max-width="21" max-height="26" contain></v-img>
                      <span class="add-new-research__text">Добавить полис</span>
                    </div>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-card v-if="insurances && insurances.length>0">
                      <v-card-title>Связанные полиса</v-card-title>
                      <v-card-text>
                        <v-row v-for="(insurance, index) in insurances" :key="'ins_' + index" @click="open_insurance(insurance)">
                          <span style="cursor: pointer">
                            <font color="orange">Страховой полис серия: {{insurance.doc.series}} номер: {{insurance.doc.number}}<br>
                            {{dict.insurer[insurance.insurer]}}<br>
                            {{dict.insurance_product[insurance.product]}}
                            </font>
                          </span>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-tab-item>
              <v-tab-item>
                <v-row>
                  <v-col cols="4">
                    <v-checkbox
                      v-model="form.other_object"
                      label="Указать объект страхования"
                    />
                  </v-col>
                  <v-col cols="8" v-if="form.other_object">
                    <v-text-field
                      v-model="form.object"
                      label="Объект страхования"
                    />
                  </v-col>
                </v-row>
                <v-row v-if="!form.other_object">
                  <v-col cols="8">
                    <v-autocomplete
                      v-model="form.vehicle"
                      editable
                      :search-input.sync="search.vehicle.value"
                      :filter="vehicle_filter"
                      :items="select.vehicles"
                      item-value="id"
                      label="Выберите ТС"
                      :disabled="view"
                      @change="vehicle_changed"
                    >
                      <template v-slot:selection="{item}">
                        <v-list>
                          <v-list-item-content>
                            <v-list-item-title> {{ item.model }} {{ item.vin }} </v-list-item-title>
                          </v-list-item-content>
                        </v-list>
                      </template>
                      <template v-slot:item="{item}">
                        <v-list two-line>
                          <v-list-item-content>
                            <v-list-item-title> {{ item.model }} </v-list-item-title>
                            <v-list-item-subtitle class="blue--text"> {{item.vin}} </v-list-item-subtitle>
                            <v-list-item-subtitle class="purple--text"> {{item.number}} </v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list>
                      </template>
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="4">
                    <v-btn color="warning" @click="clear_vehicle" max-width=100>Очистить</v-btn>
                  </v-col>
                </v-row>
                <v-row v-if="!form.other_object">
                  <v-col
                    cols="5"
                  >
                    <v-text-field
                      v-model="form.vehicle_item.model"
                      :rules="[(v) => !!v || 'Заполните поле']"
                      color="secondary"
                      label="Марка транспортного средства"
                      prepend-icon="mdi-car"
                      type="text"
                      :disabled="view"
                      @input="()=>form.vehicle_item.model = form.vehicle_item.model.toUpperCase()"
                    />
                  </v-col>
                  <v-col
                    v-if="!form.vehicle_item.without_vin"
                    cols="5"
                  >
                    <v-text-field
                      v-model="form.vehicle_item.vin"
                      :counter="17"
                      :rules="[(v) => !!v || 'Заполните поле', (v) => /^[0-9A-Z]{17}$/.test(v) || 'VIN должен состоять только из латинских букв и цифр']"
                      color="secondary"
                      label="VIN"
                      prepend-icon="mdi-barcode"
                      maxlength="17"
                      :disabled="view"
                      @input="()=>{form.vehicle_item.vin = form.vehicle_item.vin.toUpperCase().substring(0,17),check_vehicle_existance(form.vehicle_item, (data) => {
                                  form.vehicle_item = data,
                                  form.vehicle = data.id
                                },
                                ()=>{
                                  form.vehicle_item.create_new = true
                                })}"
                    />
                  </v-col>
                  <v-col
                    v-if="form.vehicle_item.without_vin"
                    cols="5"
                  >
                    <v-text-field
                      v-model="form.vehicle_item.body"
                      :counter="17"
                      :rules="[(v) => !!v || 'Заполните поле', (v) => /^[0-9A-Z]+$/.test(v) || 'Номер кузова должен состоять только из латинских букв и цифр']"
                      color="secondary"
                      label="Номер кузова"
                      prepend-icon="mdi-barcode"
                      maxlength="17"
                      :disabled="view"
                      @input="()=>{form.vehicle_item.body = form.vehicle_item.body.toUpperCase().substring(0,17),check_vehicle_existance(form.vehicle_item, (data) => {
                                  form.vehicle_item = data,
                                  form.vehicle = data.id
                                },
                                ()=>{
                                  form.vehicle_item.create_new = true
                                })}"
                    />
                  </v-col>
                  <v-col cols="2">
                    <v-checkbox
                      v-model="form.vehicle_item.without_vin"
                      color="secondary"
                      label="VIN отсутствует"
                      :disabled="view"
                    />
                  </v-col>
                  <v-col cols="5">
                    <v-text-field
                      v-model="form.vehicle_item.number"
                      :disabled="form.vehicle_item.without_number || view"
                      color="secondary"
                      label="Госномер"
                      prepend-icon="mdi-barcode-scan"
                      @input="()=>form.vehicle_item.number = form.vehicle_item.number.toUpperCase()"
                    />
                  </v-col>
                  <v-col cols="2">
                    <v-checkbox
                      v-model="form.vehicle_item.without_number"
                      color="secondary"
                      label="Отсутствует"
                      :disabled="view"
                    />
                  </v-col>
                  <v-col cols="5">
                    <v-text-field
                      v-model="form.vehicle_item.date"
                      color="secondary"
                      type="number"
                      :rules="[(v) => !!v || 'Заполните поле',(v) => /^.{4}$/.test(v) || 'Неверное значение']"
                      label="Год выпуска ТС"
                      :disabled="view"
                    />
                  </v-col>
                  <v-col cols="3">
                    <v-select
                      v-model="form.vehicle_item.doc_type"
                      :rules="[(v) => !!v || 'Заполните поле']"
                      :items="dict.doc_type"
                      color="secondary"
                      label="Тип документа"
                      :disabled="view"
                    />
                  </v-col>
                  <v-col cols="3">
                    <v-text-field
                      v-model="form.vehicle_item.doc.series"
                      :counter="4"
                      :rules="[(v) => !!v || 'Заполните поле',(v) => /^.{4}$/.test(v) || 'Неверное значение!']"
                      color="secondary"
                      label="Серия документа"
                      prepend-icon="mdi-file-document-box"
                      maxlength="4"
                      :disabled="view"
                      @input="()=>form.vehicle_item.doc.series = form.vehicle_item.doc.series.toUpperCase().substring(0,4)"
                    />
                  </v-col>
                  <v-col cols="3">
                    <v-text-field
                      v-model="form.vehicle_item.doc.number"
                      :counter="6"
                      :rules="[(v) => !!v || 'Заполните поле',(v) => /^.{6}$/.test(v) || 'Неверное значение']"
                      color="secondary"
                      label="Номер документа"
                      maxlength="6"
                      :disabled="view"
                      @input="()=>form.vehicle_item.doc.number = form.vehicle_item.doc.number.toUpperCase().substring(0,6)"
                    />
                  </v-col>
                  <v-col cols="3">
                    <v-text-field
                      v-model="form.vehicle_item.doc.date"
                      type="date"
                      label="Дата выдачи"
                      :disabled="view"
                    />
                  </v-col>
                </v-row>
              </v-tab-item>
              <v-tab-item>
                <v-row>
                  <v-col cols="8">
                    <v-autocomplete
                      v-model="form.insurant_item.id"
                      editable
                      :filter="name_filter"
                      :items="select.clients"
                      item-value="id"
                      label="Выберите страхователя"
                      :disabled="view"
                      @change="insurant_changed"
                    >
                      <template v-slot:selection="{item}">
                        <v-list>
                          <v-list-item-content>
                            <v-list-item-title> {{ item.surname }} {{ item.name }} {{ item.patronymic }}</v-list-item-title>
                          </v-list-item-content>
                        </v-list>
                      </template>
                      <template v-slot:item="{item}">
                        <v-list two-line>
                          <v-list-item-content>
                            <v-list-item-title> {{ item.surname }} {{ item.name }} {{ item.patronymic }}</v-list-item-title>
                            <v-list-item-subtitle>{{ item.birthday }}</v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list>
                      </template>
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="4">
                    <v-btn color="warning" @click="clear_insurant" max-width=100>Очистить</v-btn>
                  </v-col>
                  <v-col cols="12">
                    <v-expansion-panels v-model="insurant_panel">
                      <v-expansion-panel>
                        <v-expansion-panel-header>
                          Основное
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-row>
                            <v-col cols="4">
                              <v-text-field
                                v-model="form.insurant_item.surname"
                                v-validate="'required'"
                                color="secondary"
                                label="Фамилия"
                                prepend-icon="mdi-home"
                                validate-on-blur
                                :disabled="view"
                                @input="()=> {form.insurant_item.surname=form.insurant_item.surname.toUpperCase(), check_client_existance(form.insurant_item, (data) => {
                                  form.insurant_item = data,
                                  form.insurant = data.id
                                },
                                ()=>{
                                  form.insurant_item.create_new = true
                                })}"
                              />
                            </v-col>
                            <v-col cols="4">
                              <v-text-field
                                v-model="form.insurant_item.name"
                                v-validate="'required'"
                                color="secondary"
                                label="Имя"
                                prepend-icon="mdi-home"
                                validate-on-blur
                                :disabled="view"
                                @input="()=>{form.insurant_item.name=form.insurant_item.name.toUpperCase(), check_client_existance(form.insurant_item, (data) => {
                                  form.insurant_item = data,
                                  form.insurant = data.id
                                },
                                ()=>{
                                  form.insurant_item.create_new = true
                                })}"
                              />
                            </v-col>
                            <v-col cols="4">
                              <v-text-field
                                v-model="form.insurant_item.patronymic"
                                v-validate="'required'"
                                color="secondary"
                                label="Отчество"
                                prepend-icon="mdi-home"
                                validate-on-blur
                                :disabled="view"
                                @input="()=>{form.insurant_item.patronymic=form.insurant_item.patronymic.toUpperCase(), check_client_existance(form.insurant_item, (data) => {
                                  form.insurant_item = data,
                                  form.insurant = data.id
                                },
                                ()=>{
                                  form.insurant_item.create_new = true
                                })}"
                              />
                            </v-col>
                            <v-col cols="4">
                              <v-text-field
                                v-model="form.insurant_item.birthday"
                                color="secondary"
                                label="Дата рождения"
                                type="date"
                                :disabled="view"
                                @input="check_client_existance(form.insurant_item, (data) => {
                                  form.insurant_item = data,
                                  form.insurant = data.id
                                },
                                ()=>{
                                  form.insurant_item.create_new = true
                                })"
                              />
                            </v-col>
                            <v-col cols="4">
                              <v-text-field
                                v-model="form.insurant_item.phone"
                                label="Телефон (в формате 7XXXXXXXXXX)"
                                :disabled="view"
                                />
                            </v-col>
                            <v-col cols="4">
                              <v-text-field
                                v-model="form.insurant_item.email"
                                label="email"
                                :disabled="view"
                                />
                            </v-col>
                            <v-col cols="12">
                              <v-checkbox
                                v-model="form.insurant_item.office"
                                label="Присутствие в офисе"
                                :disabled="view"
                                />
                            </v-col>
                          </v-row>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                      <v-expansion-panel>
                        <v-expansion-panel-header>
                          Адрес
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-row v-for="(item, index) in form.insurant_item.addresses" :key="'adress_' + index">
                            <v-col
                              cols="12"
                              md="12"
                            >
                              {{ dict.address[item.type] }}
                            </v-col>
                            <v-col
                              cols="12"
                              md="12"
                            >
                              <v-text-field
                                v-model="item.value"
                                label="Адрес"
                                class="purple-input"
                                :disabled="view"
                                :name="'address' + String(index)"
                                @input="adress_input(item, index)"
                              />
                            </v-col>
                            
                          </v-row>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                      <v-expansion-panel>
                        <v-expansion-panel-header>
                          Контактные данные
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-form>
                            <v-container
                              v-for="(item, index) in form.insurant_item.phones"
                              :key="index"
                              class="py-0"
                            >
                              <v-row>
                                <v-col
                                  cols="12"
                                  md="4"
                                >
                                  <v-text-field
                                    v-model="item.number"
                                    label="Номер телефона"
                                    class="purple-input"
                                    :disabled="view"
                                  />
                                </v-col>
                                <v-col
                                  cols="12"
                                  md="5"
                                >
                                  <v-select
                                    v-model="item.type"
                                    label="Тип"
                                    class="purple-input"
                                    :disabled="view"
                                    :items="select.phone"
                                  />
                                </v-col>
                                <v-col
                                  cols="12"
                                  md="2"
                                >
                                  <v-checkbox
                                    v-model="item.main"
                                    label="Основной номер"
                                    class="purple-input"
                                    :disabled="view"
                                    @change="()=> {if (item.main) for (let x in form.insurant_item.phones) form.insurant_item.phones[x].main = false; item.main = true; if (item.main && item.type == 1) data.phone = item.number}"
                                  />
                                </v-col>
                                <v-col
                                  cols="12"
                                  md="1"
                                >
                                  <v-icon
                                    large
                                    @click="form.insurant_item.phones = form.insurant_item.phones.filter(a=>a!=item)"
                                  >
                                    mdi-minus
                                  </v-icon>
                                </v-col>
                                <v-col
                                  cols="12"
                                  md="9"
                                >
                                  <v-text-field
                                    v-model="item.comment"
                                    label="Комментарий"
                                    class="purple-input"
                                    :disabled="view"
                                  />
                                </v-col>
                                <v-col
                                  cols="12"
                                  md="3"
                                >
                                  <v-checkbox
                                    v-model="item.sms"
                                    label="Согласие на СМС"
                                    class="purple-input"
                                    :disabled="view"
                                  />
                                </v-col>
                              </v-row>
                            </v-container>
                            <v-icon
                              large
                              @click="form.insurant_item.phones.push({})"
                            >
                              mdi-plus
                            </v-icon>
                          </v-form>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                      <v-expansion-panel>
                        <v-expansion-panel-header>
                          Документы
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-form>
                            <v-container
                              v-for="(item, index) in form.insurant_item.documents"
                              :key="index"
                              class="py-0"
                            >
                              <v-row>
                                <v-col
                                  cols="12"
                                  md="11"
                                >
                                  <v-select
                                    v-model="item.type"
                                    label="Тип документа"
                                    class="purple-input"
                                    :disabled="view"
                                    :items="select.document"
                                  />
                                </v-col>
                                <v-col
                                  cols="12"
                                  md="1"
                                >
                                  <v-icon
                                    :disabled="view"
                                    large
                                    @click="form.insurant_item.documents = form.insurant_item.documents.filter(a=>a!=item)"
                                  >
                                    mdi-minus
                                  </v-icon>
                                </v-col>
                                <v-col
                                  cols="12"
                                  md="4"
                                >
                                  <v-text-field
                                    v-model="item.series"
                                    label="Серия документа"
                                    class="purple-input"
                                    :disabled="view"
                                  />
                                </v-col>
                                <v-col
                                  cols="12"
                                  md="8"
                                >
                                  <v-text-field
                                    v-model="item.number"
                                    label="Номер документа"
                                    class="purple-input"
                                    :disabled="view"
                                  />
                                </v-col>
                                <v-col
                                  cols="12"
                                  md="8"
                                >
                                  <v-text-field
                                    v-model="item.from"
                                    label="Кем выдано"
                                    class="purple-input"
                                    :disabled="view"
                                    :name="'doc_from_' + String(index)"
                                    @input="doc_from_input(item, index)"
                                  />
                                </v-col>
                                <v-col
                                  cols="12"
                                  md="4"
                                >
                                  <v-text-field
                                    v-model="item.date"
                                    type="date"
                                    label="Дата выдачи (при наличии)"
                                    class="purple-input"
                                    :disabled="view"
                                  />
                                </v-col>
                              </v-row>
                            </v-container>
                            <v-icon
                              :disabled="view"
                              large
                              @click="form.insurant_item.documents.push({})"
                            >
                              mdi-plus
                            </v-icon>
                          </v-form>
                        </v-expansion-panel-content>
                      </v-expansion-panel>

                    </v-expansion-panels>
                  </v-col>
                  
                </v-row>
              </v-tab-item>
              <v-tab-item>
                <v-row>
                  <v-col cols="8">
                    <v-autocomplete
                      v-model="form.owner_item.id"
                      editable
                      :filter="name_filter"
                      :items="select.clients"
                      item-value="id"
                      label="Выберите собственника"
                      :disabled="view"
                      @change="owner_changed"
                    >
                      <template v-slot:selection="{item}">
                        <v-list>
                          <v-list-item-content>
                            <v-list-item-title> {{ item.surname }} {{ item.name }} {{ item.patronymic }}</v-list-item-title>
                          </v-list-item-content>
                        </v-list>
                      </template>
                      <template v-slot:item="{item}">
                        <v-list two-line>
                          <v-list-item-content>
                            <v-list-item-title> {{ item.surname }} {{ item.name }} {{ item.patronymic }}</v-list-item-title>
                            <v-list-item-subtitle>{{ item.birthday }}</v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list>
                      </template>
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="4">
                    <v-btn color="warning" @click="clear_owner" max-width=100>Очистить</v-btn>
                  </v-col>
                  <v-col cols="12">
                    <v-checkbox v-model="form.owner_item.as_insurant" @change="as_insurant" label="Совпадает с страхователем"></v-checkbox>
                  </v-col>
                  <v-col
                    cols="12"
                  >
                    <v-expansion-panels v-model="owner_panel">
                      <v-expansion-panel>
                        <v-expansion-panel-header>
                          Основное
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-row>
                            <v-col cols="4">
                              <v-text-field
                                v-model="form.owner_item.surname"
                                v-validate="'required'"
                                color="secondary"
                                label="Фамилия"
                                prepend-icon="mdi-home"
                                validate-on-blur
                                :disabled="view"
                                @input="()=>{form.owner_item.surname=form.owner_item.surname.toUpperCase(),check_client_existance(form.owner_item, (data) => {
                                  form.owner_item = data,
                                  form.owner = data.id
                                },
                                ()=>{
                                  form.owner_item.create_new = true
                                })}"
                              />
                            </v-col>
                            <v-col cols="4">
                              <v-text-field
                                v-model="form.owner_item.name"
                                v-validate="'required'"
                                color="secondary"
                                label="Имя"
                                prepend-icon="mdi-home"
                                validate-on-blur
                                :disabled="view"
                                @input="()=>{form.owner_item.name=form.owner_item.name.toUpperCase(),check_client_existance(form.owner_item, (data) => {
                                  form.owner_item = data,
                                  form.owner = data.id
                                },
                                ()=>{
                                  form.owner_item.create_new = true
                                })}"
                              />
                            </v-col>
                            <v-col cols="4">
                              <v-text-field
                                v-model="form.owner_item.patronymic"
                                v-validate="'required'"
                                color="secondary"
                                label="Отчество"
                                prepend-icon="mdi-home"
                                validate-on-blur
                                :disabled="view"
                                @input="()=>{form.owner_item.patronymic=form.owner_item.patronymic.toUpperCase(),check_client_existance(form.owner_item, (data) => {
                                  form.owner_item = data,
                                  form.owner = data.id
                                },
                                ()=>{
                                  form.owner_item.create_new = true
                                })}"
                              />
                            </v-col>
                            <v-col cols="4">
                              <v-text-field
                                v-model="form.owner_item.birthday"
                                color="secondary"
                                label="Дата рождения"
                                type="date"
                                :disabled="view"
                                @input="check_client_existance(form.owner_item, (data) => {
                                  form.owner_item = data,
                                  form.owner = data.id
                                },
                                ()=>{
                                  form.owner_item.create_new = true
                                })"
                              />
                            </v-col>
                            <v-col cols="4">
                              <v-text-field
                                v-model="form.owner_item.phone"
                                label="Телефон (в формате 7XXXXXXXXXX)"
                                :disabled="view"
                                />
                            </v-col>
                            <v-col cols="4">
                              <v-text-field
                                v-model="form.owner_item.email"
                                label="email"
                                :disabled="view"
                                />
                            </v-col>
                            <v-col cols="12">
                              <v-checkbox
                                v-model="form.owner_item.office"
                                label="Присутствие в офисе"
                                :disabled="view"
                                />
                            </v-col>
                          </v-row>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                      <v-expansion-panel>
                        <v-expansion-panel-header>
                          Адрес
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-row v-for="(item, index) in form.owner_item.addresses" :key="'adress_' + index">
                            <v-col
                              cols="12"
                              md="12"
                            >
                              {{ dict.address[item.type] }}
                            </v-col>
                            <v-col
                              cols="12"
                              md="12"
                            >
                              <v-text-field
                                v-model="item.value"
                                label="Адрес"
                                class="purple-input"
                                :disabled="view"
                                :name="'address' + String(index)"
                                @input="adress_input(item, index)"
                              />
                            </v-col>
                            
                          </v-row>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                      <v-expansion-panel>
                        <v-expansion-panel-header>
                          Контактные данные
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-form>
                            <v-container
                              v-for="(item, index) in form.owner_item.phones"
                              :key="index"
                              class="py-0"
                            >
                              <v-row>
                                <v-col
                                  cols="12"
                                  md="4"
                                >
                                  <v-text-field
                                    v-model="item.number"
                                    label="Номер телефона"
                                    class="purple-input"
                                    :disabled="view"
                                  />
                                </v-col>
                                <v-col
                                  cols="12"
                                  md="5"
                                >
                                  <v-select
                                    v-model="item.type"
                                    label="Тип"
                                    class="purple-input"
                                    :disabled="view"
                                    :items="select.phone"
                                  />
                                </v-col>
                                <v-col
                                  cols="12"
                                  md="2"
                                >
                                  <v-checkbox
                                    v-model="item.main"
                                    label="Основной номер"
                                    class="purple-input"
                                    :disabled="view"
                                    @change="()=> {if (item.main) for (let x in form.owner_item.phones) form.owner_item.phones[x].main = false; item.main = true; if (item.main && item.type == 1) data.phone = item.number}"
                                  />
                                </v-col>
                                <v-col
                                  cols="12"
                                  md="1"
                                >
                                  <v-icon
                                    large
                                    @click="form.owner_item.phones = form.owner_item.phones.filter(a=>a!=item)"
                                  >
                                    mdi-minus
                                  </v-icon>
                                </v-col>
                                <v-col
                                  cols="12"
                                  md="9"
                                >
                                  <v-text-field
                                    v-model="item.comment"
                                    label="Комментарий"
                                    class="purple-input"
                                    :disabled="view"
                                  />
                                </v-col>
                                <v-col
                                  cols="12"
                                  md="3"
                                >
                                  <v-checkbox
                                    v-model="item.sms"
                                    label="Согласие на СМС"
                                    class="purple-input"
                                    :disabled="view"
                                  />
                                </v-col>
                              </v-row>
                            </v-container>
                            <v-icon
                              large
                              @click="form.owner_item.phones.push({})"
                            >
                              mdi-plus
                            </v-icon>
                          </v-form>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                      <v-expansion-panel>
                        <v-expansion-panel-header>
                          Документы
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-form>
                            <v-container
                              v-for="(item, index) in form.owner_item.documents"
                              :key="index"
                              class="py-0"
                            >
                              <v-row>
                                <v-col
                                  cols="12"
                                  md="11"
                                >
                                  <v-select
                                    v-model="item.type"
                                    label="Тип документа"
                                    class="purple-input"
                                    :disabled="view"
                                    :items="select.document"
                                  />
                                </v-col>
                                <v-col
                                  cols="12"
                                  md="1"
                                >
                                  <v-icon
                                    :disabled="view"
                                    large
                                    @click="form.owner_item.documents = form.owner_item.documents.filter(a=>a!=item)"
                                  >
                                    mdi-minus
                                  </v-icon>
                                </v-col>
                                <v-col
                                  cols="12"
                                  md="4"
                                >
                                  <v-text-field
                                    v-model="item.series"
                                    label="Серия документа"
                                    class="purple-input"
                                    :disabled="view"
                                  />
                                </v-col>
                                <v-col
                                  cols="12"
                                  md="8"
                                >
                                  <v-text-field
                                    v-model="item.number"
                                    label="Номер документа"
                                    class="purple-input"
                                    :disabled="view"
                                  />
                                </v-col>
                                <v-col
                                  cols="12"
                                  md="8"
                                >
                                  <v-text-field
                                    v-model="item.from"
                                    label="Кем выдано"
                                    class="purple-input"
                                    :disabled="view"
                                    :name="'doc_from_' + String(index)"
                                    @input="doc_from_input(item, index)"
                                  />
                                </v-col>
                                <v-col
                                  cols="12"
                                  md="4"
                                >
                                  <v-text-field
                                    v-model="item.date"
                                    type="date"
                                    label="Дата выдачи (при наличии)"
                                    class="purple-input"
                                    :disabled="view"
                                  />
                                </v-col>
                              </v-row>
                            </v-container>
                            <v-icon
                              :disabled="view"
                              large
                              @click="form.owner_item.documents.push({})"
                            >
                              mdi-plus
                            </v-icon>
                          </v-form>
                        </v-expansion-panel-content>
                      </v-expansion-panel>

                    </v-expansion-panels>
                    </v-col>
                </v-row>
              </v-tab-item>
              <v-tab-item>
                <v-row>
                  <v-col cols="8">
                    <v-autocomplete
                      v-model="form.driver_item.id"
                      editable
                      :filter="name_filter"
                      :items="select.clients"
                      item-value="id"
                      label="Выберите водителя"
                      :disabled="view"
                      @change="driver_changed"
                    >
                      <template v-slot:selection="{item}">
                        <v-list>
                          <v-list-item-content>
                            <v-list-item-title> {{ item.surname }} {{ item.name }} {{ item.patronymic }}</v-list-item-title>
                          </v-list-item-content>
                        </v-list>
                      </template>
                      <template v-slot:item="{item}">
                        <v-list two-line>
                          <v-list-item-content>
                            <v-list-item-title> {{ item.surname }} {{ item.name }} {{ item.patronymic }}</v-list-item-title>
                            <v-list-item-subtitle>{{ item.birthday }}</v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list>
                      </template>
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="4">
                    <v-btn color="warning" @click="clear_driver" max-width=100>Очистить</v-btn>
                  </v-col>
                  <v-col cols="12">
                    <v-checkbox v-model="form.driver_item.as_owner" @change="as_owner" label="Совпадает с собственником"></v-checkbox>
                  </v-col>
                  <v-col cols="12">
                    <v-checkbox v-model="form.driver_item.as_insurant" @change="driver_as_insurant" label="Совпадает с страхователем"></v-checkbox>
                  </v-col>
                  <v-col
                    cols="12"
                  >
                    <v-expansion-panels v-model="driver_panel">
                      <v-expansion-panel>
                        <v-expansion-panel-header>
                          Основное
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-row>
                            <v-col cols="4">
                              <v-text-field
                                v-model="form.driver_item.surname"
                                v-validate="'required'"
                                color="secondary"
                                label="Фамилия"
                                prepend-icon="mdi-home"
                                validate-on-blur
                                :disabled="view"
                                @input="()=>{form.driver_item.surname=form.driver_item.surname.toUpperCase(),check_client_existance(form.driver_item, (data) => {
                                  form.driver_item = data,
                                  form.driver = data.id
                                },
                                ()=>{
                                  form.driver_item.create_new = true
                                })}"
                              />
                            </v-col>
                            <v-col cols="4">
                              <v-text-field
                                v-model="form.driver_item.name"
                                v-validate="'required'"
                                color="secondary"
                                label="Имя"
                                prepend-icon="mdi-home"
                                validate-on-blur
                                :disabled="view"
                                @input="()=>{form.driver_item.name=form.driver_item.name.toUpperCase(),check_client_existance(form.driver_item, (data) => {
                                  form.driver_item = data,
                                  form.driver = data.id
                                },
                                ()=>{
                                  form.driver_item.create_new = true
                                })}"
                              />
                            </v-col>
                            <v-col cols="4">
                              <v-text-field
                                v-model="form.driver_item.patronymic"
                                v-validate="'required'"
                                color="secondary"
                                label="Отчество"
                                prepend-icon="mdi-home"
                                validate-on-blur
                                :disabled="view"
                                @input="()=>{form.driver_item.patronymic=form.driver_item.patronymic.toUpperCase(),check_client_existance(form.driver_item, (data) => {
                                  form.driver_item = data,
                                  form.driver = data.id
                                },
                                ()=>{
                                  form.driver_item.create_new = true
                                })}"
                              />
                            </v-col>
                            <v-col cols="4">
                              <v-text-field
                                v-model="form.driver_item.birthday"
                                color="secondary"
                                label="Дата рождения"
                                type="date"
                                :disabled="view"
                                @input="check_client_existance(form.driver_item, (data) => {
                                  form.driver_item = data,
                                  form.driver = data.id
                                },
                                ()=>{
                                  form.driver_item.create_new = true
                                })"
                              />
                            </v-col>
                            <v-col cols="4">
                              <v-text-field
                                v-model="form.driver_item.phone"
                                label="Телефон (в формате 7XXXXXXXXXX)"
                                :disabled="view"
                                />
                            </v-col>
                            <v-col cols="4">
                              <v-text-field
                                v-model="form.driver_item.email"
                                label="email"
                                :disabled="view"
                                />
                            </v-col>
                            <v-col cols="12">
                              <v-checkbox
                                v-model="form.driver_item.office"
                                label="Присутствие в офисе"
                                :disabled="view"
                                />
                            </v-col>
                          </v-row>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                      <v-expansion-panel>
                        <v-expansion-panel-header>
                          Адрес
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-row v-for="(item, index) in form.driver_item.addresses" :key="'adress_' + index">
                            <v-col
                              cols="12"
                              md="12"
                            >
                              {{ dict.address[item.type] }}
                            </v-col>
                            <v-col
                              cols="12"
                              md="12"
                            >
                              <v-text-field
                                v-model="item.value"
                                label="Адрес"
                                class="purple-input"
                                :disabled="view"
                                :name="'address' + String(index)"
                                @input="adress_input(item, index)"
                              />
                            </v-col>
                            
                          </v-row>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                      <v-expansion-panel>
                        <v-expansion-panel-header>
                          Контактные данные
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-form>
                            <v-container
                              v-for="(item, index) in form.driver_item.phones"
                              :key="index"
                              class="py-0"
                            >
                              <v-row>
                                <v-col
                                  cols="12"
                                  md="4"
                                >
                                  <v-text-field
                                    v-model="item.number"
                                    label="Номер телефона"
                                    class="purple-input"
                                    :disabled="view"
                                  />
                                </v-col>
                                <v-col
                                  cols="12"
                                  md="5"
                                >
                                  <v-select
                                    v-model="item.type"
                                    label="Тип"
                                    class="purple-input"
                                    :disabled="view"
                                    :items="select.phone"
                                  />
                                </v-col>
                                <v-col
                                  cols="12"
                                  md="2"
                                >
                                  <v-checkbox
                                    v-model="item.main"
                                    label="Основной номер"
                                    class="purple-input"
                                    :disabled="view"
                                    @change="()=> {if (item.main) for (let x in form.driver_item.phones) form.driver_item.phones[x].main = false; item.main = true; if (item.main && item.type == 1) data.phone = item.number}"
                                  />
                                </v-col>
                                <v-col
                                  cols="12"
                                  md="1"
                                >
                                  <v-icon
                                    large
                                    @click="form.driver_item.phones = form.driver_item.phones.filter(a=>a!=item)"
                                  >
                                    mdi-minus
                                  </v-icon>
                                </v-col>
                                <v-col
                                  cols="12"
                                  md="9"
                                >
                                  <v-text-field
                                    v-model="item.comment"
                                    label="Комментарий"
                                    class="purple-input"
                                    :disabled="view"
                                  />
                                </v-col>
                                <v-col
                                  cols="12"
                                  md="3"
                                >
                                  <v-checkbox
                                    v-model="item.sms"
                                    label="Согласие на СМС"
                                    class="purple-input"
                                    :disabled="view"
                                  />
                                </v-col>
                              </v-row>
                            </v-container>
                            <v-icon
                              large
                              @click="form.driver_item.phones.push({})"
                            >
                              mdi-plus
                            </v-icon>
                          </v-form>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                      <v-expansion-panel>
                        <v-expansion-panel-header>
                          Документы
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-form>
                            <v-container
                              v-for="(item, index) in form.driver_item.documents"
                              :key="index"
                              class="py-0"
                            >
                              <v-row>
                                <v-col
                                  cols="12"
                                  md="11"
                                >
                                  <v-select
                                    v-model="item.type"
                                    label="Тип документа"
                                    class="purple-input"
                                    :disabled="view"
                                    :items="select.document"
                                  />
                                </v-col>
                                <v-col
                                  cols="12"
                                  md="1"
                                >
                                  <v-icon
                                    :disabled="view"
                                    large
                                    @click="form.driver_item.documents = form.driver_item.documents.filter(a=>a!=item)"
                                  >
                                    mdi-minus
                                  </v-icon>
                                </v-col>
                                <v-col
                                  cols="12"
                                  md="4"
                                >
                                  <v-text-field
                                    v-model="item.series"
                                    label="Серия документа"
                                    class="purple-input"
                                    :disabled="view"
                                  />
                                </v-col>
                                <v-col
                                  cols="12"
                                  md="8"
                                >
                                  <v-text-field
                                    v-model="item.number"
                                    label="Номер документа"
                                    class="purple-input"
                                    :disabled="view"
                                  />
                                </v-col>
                                <v-col
                                  cols="12"
                                  md="8"
                                >
                                  <v-text-field
                                    v-model="item.from"
                                    label="Кем выдано"
                                    class="purple-input"
                                    :disabled="view"
                                    :name="'doc_from_' + String(index)"
                                    @input="doc_from_input(item, index)"
                                  />
                                </v-col>
                                <v-col
                                  cols="12"
                                  md="4"
                                >
                                  <v-text-field
                                    v-model="item.date"
                                    type="date"
                                    label="Дата выдачи (при наличии)"
                                    class="purple-input"
                                    :disabled="view"
                                  />
                                </v-col>
                              </v-row>
                            </v-container>
                            <v-icon
                              :disabled="view"
                              large
                              @click="form.driver_item.documents.push({})"
                            >
                              mdi-plus
                            </v-icon>
                          </v-form>
                        </v-expansion-panel-content>
                      </v-expansion-panel>

                    </v-expansion-panels>
                    </v-col>
                </v-row>
              </v-tab-item>
            </base-material-tabs>
          </form>
          <v-card-actions>
            <v-btn
              :disabled="loader.show"
              color="secondary"
              min-width="250"
              @click="$emit('close')"
            >
              Назад
            </v-btn>
            <v-btn
              v-if="!view"
              :disabled="loader.show"
              color="primary"
              min-width="250"
              @click="insurance_save"
            >
              Сохранить
            </v-btn>
            <v-menu v-if="form.id">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="ml-5"
                  color="blue"
                  
                  v-bind="attrs"
                  v-on="on"
                ><v-icon>mdi-arrow-down-bold</v-icon>
                  <span class="mx-5">
                    <font color="white">
                      Действия со страховым полисом
                    </font>
                  </span>
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="insurance_action(0)">
                  <v-list-item-title>Пролонгация полиса</v-list-item-title>
                </v-list-item>
                <v-list-item @click="insurance_action(1)">
                  <v-list-item-title>Клиент продал ТС</v-list-item-title>
                </v-list-item>
                <v-list-item @click="insurance_action(2)">
                  <v-list-item-title>Отказ от страхования.</v-list-item-title>
                </v-list-item>
                <v-list-item @click="insurance_action(3)">
                  <v-list-item-title>Застрахован в другом месте.</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-card-actions>
        </base-material-card>
        
      </v-col>
      <v-col
        v-if="view"
        cols="12"
        md="6"
      >
        <base-material-card
          class="v-card-profile"
          title="События"
        >
          <v-card-text>
            <div
              v-for="(item,index) in events"
              :key="index"
              style="cursor: pointer"
            >
              <event-form
                v-if="index == active"
                :create="!item.id"
                :view="false"
                :change="!!item.id"
                :data="item"
                :show="true"
                :short="true"
                @close="event_close"
              />
              <v-row v-else  @click="active = index" class="select_row">
                <v-col cols="2">
                  <v-icon v-if="$store.state.dict.events[item.type]>0" large :color="$store.state.dict.events[item.type].color">{{ $store.state.dict.events[item.type].icon }}</v-icon>
                </v-col>
                <v-col cols="4">
                  <font v-if="$store.state.dict.events[item.type]>0" :color="$store.state.dict.events[item.type].color">{{ $store.state.dict.events[item.type].name }} {{ format_start(item.date, item.time) }}<br></font>
                  <font color="#db7093"><span v-if="item.user">{{ item.user_item.surname }} {{ item.user_item.name }} {{ item.user_item.patronymic }}</span><br></font>
                  <b>{{dict.state[item.state]}}</b>
                  
                </v-col>
                <v-col cols="6">
                  <font color="blue">{{item.text}}</font>
                </v-col>
              </v-row>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn
              color="primary"
              min-width="100"
              @click="showCreateEvent"
            >
              Создать
            </v-btn>
          </v-card-actions>
        </base-material-card>
        <base-material-card
          color="success"
          class="v-card-profile"
          title="Комментарии"
        >
          <v-card-text>
            <v-data-table
              :items="comments"
              :headers="headers.comment"
              hide-default-header
              :footerProps="datatable_footer"
            >
              <template v-slot:footer.page-text="{pageStart,pageStop,itemsLength}">
              {{ pageStart }}-{{ pageStop }} из {{itemsLength}}
              </template>
              <template v-slot:item.created="{item}">
                {{item.created}}<br>
                <font color="#db7093">{{item.creator_name}}</font>
              </template>
              <template v-slot:item.text="{item}">
                <font color="blue">{{item.text}}</font>
              </template>
            </v-data-table>
          </v-card-text>
          <v-card-actions>
            <v-row>
              <v-col cols="8">
                <v-text-field
                  v-model="comment"
                  label="Введите комментарий"
                />
              </v-col>
              <v-col cols="4">
                <v-btn
                  :disabled="!comment || comment.length == 0"
                  color="primary"
                  @click="create_comment"
                >
                  <span class="mx-5">Добавить</span>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </base-material-card>
      </v-col>
    </v-row>
      <v-dialog
        v-model="dialog.event.show"
        scrollable
        persistent
      >
        <event-form
          :create="dialog.event.create"
          :view="dialog.event.view"
          :change="dialog.event.change"
          :data="dialog.event.data"
          :show="dialog.event.show"
          @close="(a) => { dialog.event.show = false, load_events(a.id) }"
        />
      </v-dialog>
      <v-dialog v-model="dialog.client.show" persistent>
        <clients-form
          :create="dialog.client.create"
          :view="dialog.client.view"
          :change="dialog.client.change"
          :item="dialog.client.data"
          @create="create_client"
          @close="client_close"
        />
      </v-dialog>
      <v-dialog v-model="dialog.vehicle.show" persistent>
        <VehicleForm
          :create="dialog.vehicle.create"
          :view="dialog.vehicle.view"
          :change="dialog.vehicle.change"
          :show="dialog.vehicle.show"
          :data="dialog.vehicle.data"
          @close="vehicle_close"
        />
      </v-dialog>
      <v-dialog v-model="dialog.vehicle_list.show" persistent>
        <VehicleList
          :show="dialog.vehicle_list.show"
          :multiple="false"
          :choose="true"
          @close="dialog.vehicle_list.show = false"
          @select="vehicle_select"
        />
      </v-dialog>
      <v-dialog v-model="dialog.insurance.show" persistent>
        <InsuranceForm
          :create="dialog.insurance.create"
          :view="dialog.insurance.view"
          :change="dialog.insurance.change"
          :show="dialog.insurance.show"
          :vehicle="dialog.insurance.vehicle"
          :insurant="dialog.insurance.insurant"
          :data="dialog.insurance.data"
          :old="dialog.insurance.old"
          @close="dialog.insurance.show = false,  $emit('close')"
        />
      </v-dialog>
      <v-dialog v-model="dialog.client_exists.show" persistent>
        <v-card>
          <v-card-title>Уже существуют клиенты с такими данными. Выберите клиента или создайте  нового</v-card-title>
          <v-card-text>
            <v-data-table
              :headers="[
                {value: 'surname', text: 'Фамилия'},
                {value: 'name', text: 'Имя'},
                {value: 'patronymic', text: 'Отчество'},
                {value: 'birthday_text', text: 'Дата рождения'},
                {value: 'address', text: 'Адрес'}
              ]"
              :items="dialog.client_exists.data"
              @click:row="(a)=>{dialog.client_exists.cb(a), dialog.client_exists.show= false}"
              >
            </v-data-table>
          </v-card-text>
          <v-card-action>
            <v-btn
            color="warning"
            @click="dialog.client_exists.cn(), dialog.client_exists.show= false"
            >
            <span class="mx-5">
              Создать нового клиента
            </span>
            </v-btn>
          </v-card-action>
        </v-card>
      </v-dialog>  
      <v-dialog v-model="dialog.insurance_exists.show" persistent>
        <v-card>
          <v-card-title>Уже существуют страховые полиса с такими данными. Выберите полис или создайте новый</v-card-title>
          <v-card-text>
            <v-data-table
              :headers="[
                {
          text: 'Информация',
          value: 'information',
        },
        {
          text: 'Полис',
          value: 'doc',
        },
        {
          text: 'Период действия',
          value: 'date',
        },
        {
          text: 'Страхователь',
          value: 'insurer',
        },
        {
          text: 'Объект страхования',
          value: 'vehicle',
        },
              ]"
              :items="dialog.insurance_exists.data"
              @click:row="(a)=>{dialog.insurance_exists.cb(a), dialog.insurance_exists.show= false}"
              >
              <template v-slot:item.information="{ item }">
            <span v-if="item.doc && item.doc.date"> {{ format(item.doc.date)}}</span><br>
            {{dict.insurance_state[item.state]}}<br>
            <span v-if="item.user">{{formatName(item.user)}}</span>
            <span v-else>Система</span>
          </template>
          <template v-slot:item.doc="{ item }">
            <span v-if="item.insurer>0">
              {{ item.insurer_text }}<br>
              <font  v-if="dict.insurance_product[item.product]" :color="dict.insurance_product_color[item.product]">{{ dict.insurance_product[item.product]}}<br></font>
              {{ item.doc.series }} {{ item.doc.number }}
            </span>
          </template>
          <template v-slot:item.date="{item}">
            <span v-if="item.doc && item.doc.from_date"> {{ format(item.doc.from_date)}}</span><br>
            <span v-if="item.doc && item.doc.date"> {{ format(item.doc.date)}}</span>
          </template>
          <template v-slot:item.insurer="{item}">
            <span v-if="item.insurant_item">
              {{ item.insurant_item.surname }} {{ item.insurant_item.name }} {{ item.insurant_item.patronymic }}<br>
            </span>
          </template>
          <template v-slot:item.vehicle="{item}">
            <div v-if="item.vehicle_item">
              {{ item.vehicle_item.model }}<br>
              <font color="#db7093">{{ item.vehicle_item.number }}<br></font>
              <font color="blue">{{ item.vehicle_item.date }}</font>
            </div>
            <div>
              {{item.object}}
            </div>
          </template>
            </v-data-table>
          </v-card-text>
          <v-card-action>
            <v-btn
            color="warning"
            @click="dialog.insurance_exists.cn(), dialog.insurance_exists.show= false"
            >
            <span class="mx-5">
              Создать новый полис
            </span>
            </v-btn>
          </v-card-action>
        </v-card>
      </v-dialog>  
      <v-dialog v-model="dialog.vehicle_exists.show" persistent>
        <v-card>
          <v-card-title>Уже существуют ТС с такими данными. Выберите ТС или создайте  новое</v-card-title>
          <v-card-text>
            <v-data-table
              :headers="[
                {value: 'model', text: 'Марка'},
                {value: 'number', text: 'Номер'},
                {value: 'vin', text: 'VIN'},
                {value: 'year', text: 'Год выпуска'},
              ]"
              :items="dialog.vehicle_exists.data"
              @click:row="(a)=>{dialog.vehicle_exists.cb(a), dialog.vehicle_exists.show= false}"
              >
            </v-data-table>
          </v-card-text>
          <v-card-action>
            <v-btn
            color="warning"
            @click="dialog.vehicle_exists.cn(), dialog.vehicle_exists.show= false"
            >
            <span class="mx-5">
              Создать новое ТС
            </span>
            </v-btn>
          </v-card-action>
        </v-card>
      </v-dialog>  
  </div>
</template>
<style lang="scss">
.add-new-research {
  display: flex;
  flex-direction: row;
  cursor: pointer;
  .add-new-research__text {
    color: #727272;
    padding-left: 6px;
    line-height: 25px;
  }
}
</style>
<style>

.select_row:hover {
  background: rgba(50,50,50,0.2)
}
</style>
<script>
  import $ from 'jquery'
  import moment from 'moment'
  import EventForm from './EventForm'
import { teal } from 'color-name';
import { setTimeout } from 'timers';
  export default {
    name: 'InsuranceForm',
    components: { EventForm },
    props: ['create', 'view', 'change', 'show', 'data', 'vehicle', 'old', 'index', 'event', 'insurant'],
    data () {
      return {
        insurant_panel: 0,
        driver_panel: 0,
        owner_panel:0,
        datatable_footer: {
          itemsPerPageText: 'Показывать по', pageText: 'из',
          itemsPerPageAllText: 'Все'
        },
        comment: '',
        comments: [],
        headers: {
          comment: [
            {
              value: 'created'
            },
            {
              value: 'text'
            }
          ]
        },
        active: 0,
        suggestion: {
          owner: false,
          driver: false
        },
        tab: 0,
        loader: {
          show: false,
        },
        title: '',
        insurances: [],
        form: {
          other_object: false,
          object: "",
          state: 0,
          id: '',
          insurer: 0,
          doc: {
            series: '',
            number: '',
            date: '',
          },
          vehicle: '',
          vehicle_item: { doc: {} },
          driver_item: { driver_doc: {} },
          owner_item: { driver_doc: {} },
          insurant_item: { insurer_agent: false,
              contract_agent: false,
              agent_doc: {},
              logs: [],
              files: [],
              type: 1,
              surname: '',
              name: '',
              patronymic: '',
              email: '',
              birthday: null,
              birthplace: '',
              phones: [],
              documents: [],
              addresses: [
                {
                  index: 1,
                  value: '',
                  data: {
                    postal_code: '',
                    region_iso_code: '',
                    region_with_type: '',
                    city_with_type: '',
                    street_with_type: '',
                  },
                  type: 1,
                  suggestion: false,
                },
                {
                  index: 2,
                  value: '',
                  data: {
                    postal_code: '',
                    region_iso_code: '',
                    region_with_type: '',
                    city_with_type: '',
                    street_with_type: '',
                  },
                  type: 2,
                  suggestion: false,
                },
              ],
              requisites: {
                name: '',
                rs: '',
                ks: '',
                bic: '',
              },
              socials: [],  },
        },
        extra: [],
        dialog: {
          insurance: {
            show: false,
            view: false,
            change: false,
            create: true,
            data: {}
          },
          event: {
            show: false,
            item: {},
          },
          client: {
            show: false,
            create: false,
            change: false,
            view: false,
            data: {},
          },
          vehicle: {
            show: false,
            create: false,
            change: false,
            view: false,
            data: {},
          },
          vehicle_list: {
            show: false
          },
          client_exists: {
            show: false,
            data: [],
            cb: null
          },
          vehicle_exists: {
            show: false,
            data: [],
            cb: null
          },
          insurance_exists: {
            show: false,
            data: [],
            cb: null
          }
        },
        events: [

        ],
        select: {
          phone: [
          { value: 1, text: 'Мобильный' },
          { value: 2, text: 'Домашний' },
        ],
        document: [
          { value: 1, text: 'Паспорт' },
          { value: 2, text: 'Водительское удостоверение' },
          { value: 10, text: 'Иное' },
        ],
        social: [
          { value: 1, text: 'ВКонтакте' },
          { value: 2, text: 'Facebook' },
          { value: 3, text: 'Instagram' },
          { value: 4, text: 'Twitter' },
        ],
        event: [
          { value: 1, text: 'Звонок' },
        ],
        doc_type: [
            { value: 1, text: 'Свидетельство о регистрации ТС' },
            { value: 2, text: 'Паспорт ТС' },
            { value: 3, text: 'Паспорт самоходной машины' },
            { value: 4, text: 'Аналогичный документ' },
          ],
          file_type: [],
          agent_doc_type: [
            {value: 1, text: 'Устав'},
            {value: 2, text: 'Доверенность'}
          ],
          insurance_product: [],
           unsurance_state: [
            { value: 0, text: 'Клиентский'},
            { value: 1, text: 'Оформление Евроком'},
            { value: 2, text: 'Пролонгирован'},
            { value: 3, text: 'Клиент продал ТС'},
            {value: 4, text: 'Отказ от страхования'},
            {value: 5, text: 'Застрахован в другом месте'}
          ],
          vehicles: [],
          clients: [],
          state: [
            { value: 1, text: 'Новый' },
            { value: 2, text: 'Завершен' },
            { value: 3, text: 'Отменен' },
          ],
          type: [],
          insurer: [],
        },
        dict: {
          insurance_product_color: {},
          insurance_state: {
            0: 'Клиентский',
            1: 'Оформление Евроком',
            2: 'Пролонгирован',
            3: 'Клиент продал ТС',
            4: 'Отказ от страхования',
            5: 'Застрахован в другом месте'
          },
          phone: {
            1: 'Мобильный',
            2: 'Домашний',
          },
          address: {
            1: 'Адрес по прописке',
            2: 'Адрес проживания',
          },
          state: {
            1: 'Новый',
            2: 'Завершен',
            3: 'Отменен',
          },
          doc_type: [
            { value: 1, text: 'Свидетельство о регистрации ТС' },
            { value: 2, text: 'Паспорт ТС' },
            { value: 3, text: 'Паспорт самоходной машины' },
            { value: 4, text: 'Аналогичный документ' },
          ],
          insurer: {},
          insurance_product: {}
        },
        search: {
          vehicle: {
            loading: false,
            value: ''
          }
        }
      }
    },
    watch: {
      'search.vehicle.value': function() {
        this.search.vehicle.value = this.search.vehicle.value || ''
        if (this.search.vehicle.value.length>=3 && !this.search.vehicle.loading) {
          this.search.vehicle.loading = true
          this.$axios.post('/api/common/vehicle/list/', {search: this.search.vehicle.value})
            .then(response => {
              this.search.vehicle.loading = false
              if (!response.data.error) {
                this.select.vehicles = response.data.data
                for (let x in response.data.data) {
                  response.data.data[x].doc.date = moment(response.data.data[x].doc.date).format('YYYY-MM-DD')
                  response.data.data[x].doc.ftom_date = moment(response.data.data[x].doc.ftom_date).format('YYYY-MM-DD')
                }
              }
            })
            .catch(e => {
              this.search.vehicle.loading = false
              console.log(e)
            })
        }
      },
      show: function () {
        if (this.show) {
          console.log(this.show, 'show')
          if (this.create) this.title = 'Создание'
          if (this.change) this.title = 'Изменение'
          if (this.view) this.title = 'Просмотр'
          this.load()
          this.load_clients()
          this.load_vehicles()
          this.extra = []
          this.insurances = []
        } else {
          this.lock_off()
        }
      },
    },
    mounted: function () {
      for (let x in this.$store.state.dict.events) {
        this.select.type.push({
          value: Number(x),
          text: this.$store.state.dict.events[x].name,
        })
      }
      for (let x in this.$store.state.dict.insurance_product) {
        if (this.$store.state.dict.insurance_product[x].active == 1) {
          var insurer = {}
          for (let y in this.$store.state.dict.insurer) {
            if (this.$store.state.dict.insurer[y].key == this.$store.state.dict.insurance_product[x].insurer) {
              console.log(this.$store.state.dict.insurer[y].key, this.$store.state.dict.insurance_product[x].insurer)
              insurer.value = Number(y),
              insurer.name = this.$store.state.dict.insurer[y].name
              break;
            }
          }
          this.select.insurance_product.push({
            value: Number(x),
            text: this.$store.state.dict.insurance_product[x].name,
            color: this.$store.state.dict.insurance_product[x].color,
            insurer: insurer
          })
          this.dict.insurance_product[Number(x)] = this.$store.state.dict.insurance_product[x].name
           this.dict.insurance_product_color[Number(x)] = this.$store.state.dict.insurance_product[x].color
        }
      }
      for (let x in this.$store.state.dict.insurer) {
        this.select.insurer.push({
          value: Number(x),
          text: this.$store.state.dict.insurer[x].name,
          eurocom: this.$store.state.dict.insurer[x].eurocom
        })
        this.dict.insurer[Number(x)] = this.$store.state.dict.insurer[x].name
      }
      this.load()
      this.load_clients()
      this.load_vehicles()
    },
    methods: {
      event_close: function(data, stay, create_new) {
        console.log('event_close',data, stay, create_new )
        if (create_new) {
          this.create_new_event(data)
          return
        }
        if (!stay) {
          this.$emit('close')
          return
        }
        if (stay) {
          this.load_events(data.id);
          return
        }
      },
      create_new_event: function(event) {
        console.log(event)
        this.active = -1
        var ev =  {
          id: '',
          theme: '',
          text: '',
          date: moment().format('YYYY-MM-DD'),
          time: '12:00',
          contract: event.contract,
          accident: event.accident,
          vehicle: event.vehicle,
          contract_item: event.contract_item,
          accident_item: event.accident,
          state: 0,
          type: event.type,
          phone: event.phone,
          email: event.email,
          client: event.client,
          client_item: event.client_item,
          user: event.user,
          user_item: event.user_item,
          insurance: event.insurance,
          insurance_item: event.insurance_item,
          insurant: event.insurant,
          insuran_item: event.insurant_item
        }
        if (event.client_item && event.client_item.phone && !event.phone) {
            ev.phone =  event.client_item.phone
            }
          if (event.client_item && event.client_item.email && !event.email) {
            ev.email =  event.client_item.email
            }
        this.events.unshift(
         ev
        )
        let self = this
        setTimeout(function() {
          self.active = 0
        }, 500)
      },
      format: function(date) {
        return moment(date).format('DD.MM.YYYY')
      },
      format_full: function(date) {
        return moment(date).format('DD.MM.YYYY HH:mm:ss')
      },
      formatName: function(user) {
        let result = "";
        if (user.surname) {
          result = user.surname;
          if (user.name) {
            result += ' ' + user.name.charAt(0).toUpperCase() + '.';
             if (user.patronymic) {
              result += ' ' + user.patronymic.charAt(0).toUpperCase() + '.';
            } 
          }
        } else {
          if (user.name) {
            result = user.name;
          } 
        }
        return result;
      },
      doc_from_input: function(item, index) {
        if (item.type != 1) {
          item.suggestion = false
          return
        }
        console.log($('[name=doc_from_' + String(index) + ']'))
        if (!item.suggestion) {
          if (!item.suggestion && $('[name=doc_from_' + String(index) + ']').length > 0) {
            item.suggestion = true
            $('[name=doc_from_' + String(index) + ']').suggestions({
              token: 'eae7f9493d3e1f729fd183f9197cf1fd22c7fbcc',
              type: 'fms_unit',
              count: 5,
              onSelect: data => {
                item.code = data.data.code
                item.from = data.data.name
              },
            })
          }
        }
      },
       adress_input: function (item, index) {
        if (!item.suggestion) {
          console.log('[name=address' + String(index) + ']')
          item.suggestion = true
          $('[name=address' + String(index) + ']').suggestions({
            token: 'e34ea0b5db1995676cb5794a9c323e632feead8e',
            type: 'ADDRESS',
            count: 5,
            onSelect: data => {
              item.value = data.unrestricted_value
              item.data = data.data
              console.log(item)
            },
          })
        }
       },
      insurance_action: function(type) {
        if (type === 0) {
          this.dialog.insurance.vehicle = this.form.vehicle
          this.dialog.insurance.show = true
          this.dialog.insurance.create = true
          this.dialog.insurance.change = false
          this.dialog.insurance.view = false
          this.dialog.insurance.old = this.form.id
          this.dialog.insurance.insurant = this.form.insurant
          this.dialog.insurance.event = true
        }
        if (type === 1) {
          this.form.state = 3
          this.$axios.post('/api/common/insurance/save/', this.form)
            .then(response => {
              if (!response.data.error) {
                this.$store.commit('snackbar', 'Успешно')
                this.$emit('close')
              } else {
                this.$store.commit('snackbar', response.data.data || 'Ошибка при сохранении данных')
              }
            })
            .catch(e => {
              console.log(e)
              this.$store.commit('snackbar', 'Ошибка при сохранении данных')
            })        
        }
        if (type === 2) {
          this.form.state = 4
          this.$axios.post('/api/common/insurance/save/', this.form)
            .then(response => {
              if (!response.data.error) {
                this.$store.commit('snackbar', 'Успешно')
                 this.$emit('close')
              } else {
                this.$store.commit('snackbar', response.data.data || 'Ошибка при сохранении данных')
              }
            })
            .catch(e => {
              console.log(e)
              this.$store.commit('snackbar', 'Ошибка при сохранении данных')
            })        
        }
        if (type === 3) {
          this.form.state = 5
          var insurance_settings = this.$store.state.settings.filter(a=>a.type == 'insurance')[0]
          let days = 350
          if (insurance_settings) {
            var days_settings = insurance_settings.data.filter(a=>a.key == 'days')[0]
            days = days_settings.value || 350
          }
          this.form.doc.date = moment(this.form.doc.date).add(days, 'days').format('YYYY-MM-DD')
          this.$axios.post('/api/common/insurance/save/', this.form)
            .then(response => {
              if (!response.data.error) {
                this.$store.commit('snackbar', 'Успешно')
                 this.$emit('close')
              } else {
                this.$store.commit('snackbar', response.data.data || 'Ошибка при сохранении данных')
              }
            })
            .catch(e => {
              console.log(e)
              this.$store.commit('snackbar', 'Ошибка при сохранении данных')
            })        
        }
      },
      eurocom: function() {
        if (this.form.eurocom) {
          this.form.insurer = this.select.insurer.filter(a=>a.eurocom == "1")[0].value
          this.form.doc.series = 'YYY'
          this.form.doc.number = '1111111111'
          this.form.doc.from_date = moment().format('YYYY-MM-DD')
        }
      },
      as_owner: function() {
        if (this.form.driver_item.as_owner) {
          this.form.driver = this.form.owner
          this.form.driver_item = this.form.owner_item
          this.form.driver_item.as_owner = true
        }
      },
      as_insurant: function() {
         if (this.form.owner_item.as_insurant) {
          this.form.owner = this.form.insurant
          this.form.owner_item = this.form.insurant_item
          this.form.owner_item.as_insurant = true
        }
      },
      driver_as_insurant: function() {
         if (this.form.driver_item.as_insurant) {
          this.form.driver = this.form.insurant
          this.form.driver_item = this.form.insurant_item
          this.form.driver_item.as_insurant = true
        }
      },
      owner_address_input: function() {
        if (!this.suggestion.owner) {
          this.suggestion.owner = true
          $('[name=first_owner_address]').suggestions({
            token: 'eae7f9493d3e1f729fd183f9197cf1fd22c7fbcc',
            type: 'ADDRESS',
            count: 5,
            onSelect: data => {
              console.log(data)
              this.form.owner_item.address = data.unrestricted_value
              this.form.owner_item.address_data = data.data
            },
          })
        }
      },
      driver_address_input: function() {
        if (!this.suggestion.driver) {
          this.suggestion.driver = true
          $('[name=first_driver_address]').suggestions({
            token: 'eae7f9493d3e1f729fd183f9197cf1fd22c7fbcc',
            type: 'ADDRESS',
            count: 5,
            onSelect: data => {
              console.log(data)
              this.form.driver_item.address = data.unrestricted_value
              this.form.driver_item.address_data = data.data
            },
          })
        }
      },
      clear_vehicle: function() {
        this.form.vehicle_item = { doc: {} }
        this.form.vehicle = ""
      },
      clear_owner: function() {
        this.form.owner_item = { insurer_agent: false,
              contract_agent: false,
              agent_doc: {},
              logs: [],
              files: [],
              type: 1,
              surname: '',
              name: '',
              patronymic: '',
              email: '',
              birthday: null,
              birthplace: '',
              phones: [],
              documents: [],
              addresses: [
                {
                  index: 1,
                  value: '',
                  data: {
                    postal_code: '',
                    region_iso_code: '',
                    region_with_type: '',
                    city_with_type: '',
                    street_with_type: '',
                  },
                  type: 1,
                  suggestion: false,
                },
                {
                  index: 2,
                  value: '',
                  data: {
                    postal_code: '',
                    region_iso_code: '',
                    region_with_type: '',
                    city_with_type: '',
                    street_with_type: '',
                  },
                  type: 2,
                  suggestion: false,
                },
              ],
              requisites: {
                name: '',
                rs: '',
                ks: '',
                bic: '',
              },
              socials: [],  }
        this.form.owner = ""
      },
      clear_insurant: function() {
        this.form.insurant_item = { insurer_agent: false,
              contract_agent: false,
              agent_doc: {},
              logs: [],
              files: [],
              type: 1,
              surname: '',
              name: '',
              patronymic: '',
              email: '',
              birthday: null,
              birthplace: '',
              phones: [],
              documents: [],
              addresses: [
                {
                  index: 1,
                  value: '',
                  data: {
                    postal_code: '',
                    region_iso_code: '',
                    region_with_type: '',
                    city_with_type: '',
                    street_with_type: '',
                  },
                  type: 1,
                  suggestion: false,
                },
                {
                  index: 2,
                  value: '',
                  data: {
                    postal_code: '',
                    region_iso_code: '',
                    region_with_type: '',
                    city_with_type: '',
                    street_with_type: '',
                  },
                  type: 2,
                  suggestion: false,
                },
              ],
              requisites: {
                name: '',
                rs: '',
                ks: '',
                bic: '',
              },
              socials: [],  }
        this.form.insurant = ""
      },
      clear_driver: function() {
        this.form.driver_item = { insurer_agent: false,
              contract_agent: false,
              agent_doc: {},
              logs: [],
              files: [],
              type: 1,
              surname: '',
              name: '',
              patronymic: '',
              email: '',
              birthday: null,
              birthplace: '',
              phones: [],
              documents: [],
              addresses: [
                {
                  index: 1,
                  value: '',
                  data: {
                    postal_code: '',
                    region_iso_code: '',
                    region_with_type: '',
                    city_with_type: '',
                    street_with_type: '',
                  },
                  type: 1,
                  suggestion: false,
                },
                {
                  index: 2,
                  value: '',
                  data: {
                    postal_code: '',
                    region_iso_code: '',
                    region_with_type: '',
                    city_with_type: '',
                    street_with_type: '',
                  },
                  type: 2,
                  suggestion: false,
                },
              ],
              requisites: {
                name: '',
                rs: '',
                ks: '',
                bic: '',
              },
              socials: [],  }
        this.form.driver = ""
      },
      set_clients: function() {       
        if (this.form.vehicle_item && this.create) {
          this.form.owner_item = this.select.clients.filter(a=>a.id == this.form.vehicle_item.owner)[0] || { insurer_agent: false,
              contract_agent: false,
              agent_doc: {},
              logs: [],
              files: [],
              type: 1,
              surname: '',
              name: '',
              patronymic: '',
              email: '',
              birthday: null,
              birthplace: '',
              phones: [],
              documents: [],
              addresses: [
                {
                  index: 1,
                  value: '',
                  data: {
                    postal_code: '',
                    region_iso_code: '',
                    region_with_type: '',
                    city_with_type: '',
                    street_with_type: '',
                  },
                  type: 1,
                  suggestion: false,
                },
                {
                  index: 2,
                  value: '',
                  data: {
                    postal_code: '',
                    region_iso_code: '',
                    region_with_type: '',
                    city_with_type: '',
                    street_with_type: '',
                  },
                  type: 2,
                  suggestion: false,
                },
              ],
              requisites: {
                name: '',
                rs: '',
                ks: '',
                bic: '',
              },
              socials: [], }
          this.form.driver_item = this.select.clients.filter(a=>a.id == this.form.vehicle_item.driver)[0]         || {insurer_agent: false,
              contract_agent: false,
              agent_doc: {},
              logs: [],
              files: [],
              type: 1,
              surname: '',
              name: '',
              patronymic: '',
              email: '',
              birthday: null,
              birthplace: '',
              phones: [],
              documents: [],
              addresses: [
                {
                  index: 1,
                  value: '',
                  data: {
                    postal_code: '',
                    region_iso_code: '',
                    region_with_type: '',
                    city_with_type: '',
                    street_with_type: '',
                  },
                  type: 1,
                  suggestion: false,
                },
                {
                  index: 2,
                  value: '',
                  data: {
                    postal_code: '',
                    region_iso_code: '',
                    region_with_type: '',
                    city_with_type: '',
                    street_with_type: '',
                  },
                  type: 2,
                  suggestion: false,
                },
              ],
              requisites: {
                name: '',
                rs: '',
                ks: '',
                bic: '',
              },
              socials: [], }
        }
        if (this.create) {
          this.form.insurant_item = this.select.clients.filter(a=>a.id == this.insurant)[0]|| { insurer_agent: false,
              contract_agent: false,
              agent_doc: {},
              logs: [],
              files: [],
              type: 1,
              surname: '',
              name: '',
              patronymic: '',
              email: '',
              birthday: null,
              birthplace: '',
              phones: [],
              documents: [],
              addresses: [
                {
                  index: 1,
                  value: '',
                  data: {
                    postal_code: '',
                    region_iso_code: '',
                    region_with_type: '',
                    city_with_type: '',
                    street_with_type: '',
                  },
                  type: 1,
                  suggestion: false,
                },
                {
                  index: 2,
                  value: '',
                  data: {
                    postal_code: '',
                    region_iso_code: '',
                    region_with_type: '',
                    city_with_type: '',
                    street_with_type: '',
                  },
                  type: 2,
                  suggestion: false,
                },
              ],
              requisites: {
                name: '',
                rs: '',
                ks: '',
                bic: '',
              },
              socials: [], }
              this.form.insurant = this.form.insurant_item.id
        }
      },
      load_vehicles: function () {
        let form = {}
        if (this.create && this.vehicle) {
          form.id = this.vehicle
          this.$axios.post('/api/common/vehicle/list/', form)
            .then(response => {
              if (!response.data.error) {
                this.select.vehicles = response.data.data
                for (let x in response.data.data) {
                  response.data.data[x].doc.date = moment(response.data.data[x].doc.date).format('YYYY-MM-DD')
                  response.data.data[x].doc.ftom_date = moment(response.data.data[x].doc.ftom_date).format('YYYY-MM-DD')
                }
                if (this.create && this.vehicle) {
                  this.form.vehicle = this.vehicle
                  this.form.vehicle_item = this.select.vehicles.filter(a=>a.id == this.vehicle)[0] || {doc:{}}
                }
                this.set_clients()
              }
            })
            .catch(e => console.log(e))
        }
      },
      load_clients: function () {
        this.axios.post('/api/clients/list', {})
          .then(result => {
            if (!result.data.error) {
              for (let x in result.data.data) {
                if (result.data.data[x].birthday) result.data.data[x].birthday = moment(result.data.data[x].birthday).format('YYYY-MM-DD')
              }
              this.select.clients = result.data.data
              this.set_clients()
            }
          })
          .catch(e => console.log(e))
      },
      create_client: function (data) {        
        this.axios.post('/api/clients/create/', data)
          .then(response => {
            if (!response.data.error) {
              this.dialog.client.show = false
              this.$store.commit('snackbar', 'Успешно')
              this.select.clients.push(response.data.data)
              this.form.owner_item = this.form.owner_item || {doc: {}}
              this.form.driver_item = this.form.driver_item || {doc: {}}
              this.form.insurant_item = this.form.insurant_item || {doc: {}}
              if (this.tab == 2) {
                this.form.insurant_item = response.data.data
                this.form.insurant = response.data.data.id
                if (this.form.insurant_item.birthday) this.form.insurant_item.birthday = moment(this.form.insurant_item.birthday).format('YYYY-MM-DD')
              }
              if (this.tab == 3) {
                this.form.owner_item = response.data.data
                if (this.form.owner_item.birthday) this.form.owner_item.birthday = moment(this.form.owner_item.birthday).format('YYYY-MM-DD')
              }
              if (this.tab == 4) {
                this.form.driver_item = response.data.data
                if (this.form.driver_item.birthday) this.form.driver_item.birthday = moment(this.form.driver_item.birthday).format('YYYY-MM-DD')
              }
            } else {
              this.$store.commit('snackbar', response.data.error || 'Ошибка при сохранении данных')
            }
          })
          .catch(e => {
            this.$store.commit('snackbar', 'Ошибка при сохранении данных')
          })
      },
      create_comment: function() {
        this.$axios.post('/api/comment/create', {
          text: this.comment,
          entity: this.form.id
        })
        .then(response=> {
          if (!response.data.error) {
            this.comment = ""
            this.$store.commit('snackbar', 'Успешно')
            this.load_comments(this.form.id, false)
          } else {
            this.$store.commit('snackbar', response.data.data || 'Ошибка при сохранении данных')
          }
        })
        .catch(e => {
          this.$store.commit('snackbar', 'Ошибка при сохранении данных')
        })
      },
      check_client_existance: function(data, cb, cn) {
        if (data.create_new || data.id) return;
        if (!data.surname || !data.name || !data.birthday) return
        this.axios.post('/api/clients/list', {
          surname: data.surname,
          name: data.name,
          patronymic: data.patronymic,
          birthday: data.birthday
        }).then(response=> {
          if (!response.data.error && response.data.data[0]) {
            for (let x in response.data.data) {
              if (response.data.data[x].birthday) {
                response.data.data[x].birthday = moment(response.data.data[x].birthday).format('YYYY-MM-DD')
                response.data.data[x].birthday_text = moment(response.data.data[x].birthday).format('DD.MM.YYYY')
              }
            }
            this.dialog.client_exists.show = true
            this.dialog.client_exists.data = response.data.data
            this.dialog.client_exists.cb = cb
            this.dialog.client_exists.cn = cn
          }
        })
      },
      check_vehicle_existance: function(data, cb, cn) {
        console.log(data, cb, cn)
        if (data.create_new || data.id) return;
        if (!data.vin && !data.body) return
        var vin = data.vin || data.body
        if (vin.length < 17) return
        this.axios.post('/api/common/vehicle/list', {
          vin: vin
        }).then(response=> {
          if (!response.data.error && response.data.data[0]) {
            for (let x in response.data.data) {
            }
            this.dialog.vehicle_exists.show = true
            this.dialog.vehicle_exists.data = response.data.data
            this.dialog.vehicle_exists.cb = cb
            this.dialog.vehicle_exists.cn = cn
          }
        })
      },
      check_insurance_existance: function(data, cb, cn) {
        return
        console.log(data, cb, cn)
        if (data.create_new || data.id) return;
        if (!data.doc.number) return
        this.axios.post('/api/common/insurance/list', {
          doc: data.doc
        }).then(response=> {
          if (!response.data.error && response.data.data[0]) {
            for (let x in response.data.data) {
            }
            this.dialog.insurance_exists.show = true
            this.dialog.insurance_exists.data = response.data.data
            this.dialog.insurance_exists.cb = cb
            this.dialog.insurance_exists.cn = cn
          }
        })
      },
      client_close: function () {
        this.dialog.client.show = false
        this.load_clients()
      },
      vehicle_select: function(data) {
        this.dialog.vehicle_list.show = false
        this.form.vehicle = data[0].id
        this.form.vehicle_item = data[0]
        if (this.form.vehicle_item.doc.date) {
          this.form.vehicle_item.doc.date = moment(form.vehicle_item.doc.date).format('YYYY-MM-DD')
        }
      },
      vehicle_close: function (data) {
        this.dialog.vehicle.show = false
      },
      show_client_create_dialog: function () {
        this.dialog.client.create = true
        this.dialog.client.change = false
        this.dialog.client.view = false
        this.dialog.client.show = true
      },
      show_client_show_dialog: function (data) {
        console.log(data)
        this.dialog.client.create = false
        this.dialog.client.change = false
        this.dialog.client.view = true
        this.dialog.client.show = true
        this.dialog.client.data = data
      },
      show_vehicle_show_dialog: function (data) {
        this.dialog.vehicle.create = false
        this.dialog.vehicle.change = false
        this.dialog.vehicle.view = true
        this.dialog.vehicle.show = true
        this.dialog.vehicle.data = data
      },
      owner_changed: function (item) {
        this.form.owner_item = this.select.clients.filter(a => a.id == item)[0]
        this.form.owner_item.birthday = moment(this.form.owner_item.birthday).format('YYYY-MM-DD')
      },
      insurant_changed: function (item) {
        this.form.insurant_item = this.select.clients.filter(a => a.id == item)[0]
        this.form.insurant_item.birthday = moment(this.form.insurant_item.birthday).format('YYYY-MM-DD')
        this.form.insurant = this.form.insurant_item.id
      },
      vehicle_changed: function (item) {
        this.form.vehicle_item = this.select.vehicles.filter(a => a.id == item)[0]
        if (this.form.vehicle_item.doc.date) {
          this.form.vehicle_item.doc.date = moment(form.vehicle_item.doc.date).format('YYYY-MM-DD')
        }
      },
      driver_changed: function (item) {
        this.form.driver_item = this.select.clients.filter(a => a.id == item)[0]
        this.form.driver_item.as_owner = false
        this.form.driver_item.birthday = moment(this.form.driver_item.birthday).format('YYYY-MM-DD')
      },
      name_filter: function (item, query, text) {
        if ((item.surname + ' ' + item.name + ' ' + item.patronymic).toUpperCase().indexOf(query.toUpperCase()) > -1) return true
        return false
      },
      insurance_product_filter: function(item, query, text) {
        console.log(item, query, text)
        if (item && item.text.toUpperCase().indexOf(query.toUpperCase())>-1) return true
        if (item && item.insurer && item.insurer.name.toUpperCase().indexOf(query.toUpperCase())>-1) return true
        return false
      },
      vehicle_filter: function (item, query, text) {
        if (!item) return false
        if (item.model && (item.model).toUpperCase().indexOf(query.toUpperCase()) > -1) return true
        if (item.number && (item.number).toUpperCase().indexOf(query.toUpperCase()) > -1) return true
        if (item.vin && (item.vin).toUpperCase().indexOf(query.toUpperCase()) > -1) return true
        return false
      },
      load_insurances: function() {
        this.insurances = []
        if (this.form.id && ( (this.form.vehicle && this.form.vehicle!='000000000000000000000000') || this.form.insurant)) {
          let request = {

          }
          if (this.form.insurant) {
            request.insurant = this.form.insurant
          } else {
            request.vehicle = this.form.vehicle
          }
           this.axios.post('/api/common/insurance/list', request)
              .then(result => {
                if (!result.data.error) {
                  this.insurances = result.data.data.filter(a=>a.id!=this.form.id)
                  for (let x in this.insurances) {
                    this.load_comments(this.insurances[x].id, true)
                  }
                } else {
                    this.$store.commit('snackbar', 'Не удалось загрузить полиса')
                }
              })
              .catch(e => {
                console.log(e)
                this.$store.commit('snackbar', 'Ошибка при обновлении данных')
              })
        }
      },
      open_insurance: function(insurance) {
        this.form = JSON.parse(JSON.stringify(insurance))
        this.load_data()
      },
      load_data: function() {
        this.extra = []
        this.form.doc = this.form.doc || {}
        this.form.owner_item = this.form.owner_item || {doc: {}}
        this.form.driver_item = this.form.driver_item || {doc: {}}
        this.form.insurant_item = this.form.insurant_item || {doc: {}}
        if (this.form.owner_item.birthday) this.form.owner_item.birthday = moment(this.form.owner_item.birthday).format('YYYY-MM-DD')
        if (this.form.driver_item.birthday) this.form.driver_item.birthday = moment(this.form.driver_item.birthday).format('YYYY-MM-DD')
        if (this.form.insurant_item.birthday) this.form.insurant_item.birthday = moment(this.form.insurant_item.birthday).format('YYYY-MM-DD')
        this.form.state = this.form.state || 0
        this.form.state = Number(this.form.state)
        this.form.doc.date = moment(this.form.doc.date).format('YYYY-MM-DD')
        if (this.form.doc.from_date) this.form.doc.from_date = moment(this.form.doc.from_date).format('YYYY-MM-DD')
        this.form.vehicle_item = this.form.vehicle_item || { doc: {} }
        if (this.form.vehicle_item.doc.date) {
          this.form.vehicle_item.doc.date = moment(this.form.vehicle_item.doc.date).format('YYYY-MM-DD')
        }
        this.load_events(false)
        this.load_comments(this.form.id)
        this.load_insurances()
      },
      lock_off: function() {
        if (!this.form.id) return
        this.$store.commit('SET_LOCK_OFF', this.form.id)
        this.$axios.post('/api/lock/off/' + this.form.id)
          .then(response=> {
            if (!response.data.error) {
              
            } else {
              this.$store.commit('snackbar', response.data.data)
            }
          })
          .catch(e=>{
            console.log(e)
            this.$store.commit('snackbar', e)
          })      
      },
      load: function () {     
        this.comment = ''
        if (this.change || this.view) {
          this.$axios.post('/api/lock/on/' + this.data.id)
            .then(response=> {
              if (!response.data.error) {
                this.form = JSON.parse(JSON.stringify(this.data))
                console.log(this.form)
                this.load_data()
                this.$store.commit('SET_LOCK_ON', this.form.id)
              } else {
                this.$emit('close')
                this.$store.commit('snackbar', response.data.data)
              }
            })
            .catch(e=>{
              console.log(e)
              this.$store.commit('snackbar', e)
            })      
        } else {
          this.form = {
            state: 1,
            other_object: false,
            id: '',
            doc: {
              series: '',
              number: '',
              date: '',
            },
            vehicle: '',
            vehicle_item: { doc: {} },
            driver_item: { insurer_agent: false,
        contract_agent: false,
        agent_doc: {},
        logs: [],
        files: [],
        type: 1,
        surname: '',
        name: '',
        patronymic: '',
        email: '',
        birthday: null,
        birthplace: '',
        phones: [],
        documents: [],
        addresses: [
          {
            index: 1,
            value: '',
            data: {
              postal_code: '',
              region_iso_code: '',
              region_with_type: '',
              city_with_type: '',
              street_with_type: '',
            },
            type: 1,
            suggestion: false,
          },
          {
            index: 2,
            value: '',
            data: {
              postal_code: '',
              region_iso_code: '',
              region_with_type: '',
              city_with_type: '',
              street_with_type: '',
            },
            type: 2,
            suggestion: false,
          },
        ],
        requisites: {
          name: '',
          rs: '',
          ks: '',
          bic: '',
        },
        socials: [], },
            owner_item: { insurer_agent: false,
        contract_agent: false,
        agent_doc: {},
        logs: [],
        files: [],
        type: 1,
        surname: '',
        name: '',
        patronymic: '',
        email: '',
        birthday: null,
        birthplace: '',
        phones: [],
        documents: [],
        addresses: [
          {
            index: 1,
            value: '',
            data: {
              postal_code: '',
              region_iso_code: '',
              region_with_type: '',
              city_with_type: '',
              street_with_type: '',
            },
            type: 1,
            suggestion: false,
          },
          {
            index: 2,
            value: '',
            data: {
              postal_code: '',
              region_iso_code: '',
              region_with_type: '',
              city_with_type: '',
              street_with_type: '',
            },
            type: 2,
            suggestion: false,
          },
        ],
        requisites: {
          name: '',
          rs: '',
          ks: '',
          bic: '',
        },
        socials: [], },
            insurant_item: { 
              insurer_agent: false,
              contract_agent: false,
              agent_doc: {},
              logs: [],
              files: [],
              type: 1,
              surname: '',
              name: '',
              patronymic: '',
              email: '',
              birthday: null,
              birthplace: '',
              phones: [],
              documents: [],
              addresses: [
                {
                  index: 1,
                  value: '',
                  data: {
                    postal_code: '',
                    region_iso_code: '',
                    region_with_type: '',
                    city_with_type: '',
                    street_with_type: '',
                  },
                  type: 1,
                  suggestion: false,
                },
                {
                  index: 2,
                  value: '',
                  data: {
                    postal_code: '',
                    region_iso_code: '',
                    region_with_type: '',
                    city_with_type: '',
                    street_with_type: '',
                  },
                  type: 2,
                  suggestion: false,
                },
              ],
              requisites: {
                name: '',
                rs: '',
                ks: '',
                bic: '',
              },
              socials: [], 
            },
            insurer: 0,
          }
        }
        console.log('load end')
      },
      format_start: function(date, time) {
        return moment(date).format('DD.MM.YYYY') + ' ' + String(time).substring(0, 5)
      },
      load_events: function (id) {
        console.log('load_events', id)
        this.active = -1
        this.axios.post('/api/event/list', {
          insurance: this.form.id,
        })
          .then(result => {
            if (!result.data.error) {
              for (let x in result.data.data) {
                if (this.$store.state.dict.events[result.data.data[x].type]) result.data.data[x].color = this.$store.state.dict.events[result.data.data[x].type].color
                result.data.data[x].start = moment(result.data.data[x].date).format('DD.MM.YYYY') + ' ' + String(result.data.data[x].time).substring(0, 5)
                result.data.data[x].end = moment(result.data.data[x].date).format('YYYY-MM-DD') + ' ' + String(result.data.data[x].time).substring(0, 5)
                if (this.$store.state.dict.events[result.data.data[x].type])result.data.data[x].name = this.$store.state.dict.events[result.data.data[x].type].name
              }
              this.events = result.data.data
              this.active = this.index || 0
              if (this.event && !id) {
                this.active = this.events.indexOf(this.events.filter(a=>a.id == this.event)[0])
              }
              if (id) {
                this.active = this.events.indexOf(this.events.filter(a=>a.id == id)[0])
              }
            }
          })
          .catch(e => {
            console.log(e)
            this.$store.commit('snackbar', 'Ошибка при обновлении данных')
          })
      },
      product_change: function(id) {
        var item = this.select.insurance_product.filter(a=>a.value == id)[0]
        if (item.insurer) {
          this.form.insurer = item.insurer.value
        }
      },
      get_insurer: function(id) {
        var item = this.select.insurance_product.filter(a=>a.value == id)[0]
        if (item.insurer) {
          return item.insurer.value
        }
        return ''
      },
      load_comments: function (id, append) {
        this.axios.post('/api/comment/list', {
          entity: id,
        })
          .then(result => {
            if (!result.data.error) {
              for (let x in result.data.data) {
                result.data.data[x].creator_name = (result.data.data[x].creator.surname || "") + " " + (result.data.data[x].creator.name || "") + " " + (result.data.data[x].creator.patronymic || "")              
                result.data.data[x].created = moment(result.data.data[x].created).format('DD.MM.YYYY HH:mm:ss')
                }
              if (!append)
                this.comments = result.data.data
              else 
              for (let x in result.data.data) {
                this.comments.push(result.data.data[x])
              }
            }
          })
          .catch(e => {
            this.$store.commit('snackbar', 'Ошибка при обновлении данных')
          })
      },
      format_contract: function (number, date) {
        return number + '/' + moment(date).format('DDMM')
      },
      showEvent: function (event) {
        this.dialog.event.data = event
        this.dialog.event.show = true
        this.dialog.event.create = false
        this.dialog.event.change = true
        this.dialog.event.view = false
      },
      showCreateEvent: function (event) {
        this.dialog.event.data = {
          insurance: this.form.id,
          insurance_item: this.form,
          client: this.form.driver_item.id,
          client_item: this.form.driver_item,
          vehicle: this.form.vehicle,
          vehicle_item: this.form.vehicle_item,
        }
        this.dialog.event.show = true
        this.dialog.event.create = true
        this.dialog.event.change = false
        this.dialog.event.view = false
      },
      insurance_save: function () {
        if (!this.form.doc.date) {
          this.$store.commit('snackbar', 'Не заполнен срок действия полиса')
          return
        }
        if (!this.form.other_object && !this.form.vehicle_item.date) {
          this.$store.commit('snackbar', 'Не заполнен год выпуска ТС')
          return
        }
        this.form.old = this.old
        if (this.create) {    
          this.loader.show = true  
          this.form.extra = this.extra    
          this.$axios.post('/api/common/insurance/create/', this.form)
            .then(response => {
              this.loader.show = false  
              if (!response.data.error) {
                this.show ? this.$emit('close', response.data.data) : this.$router.push('/insurance/list')
              } else {
                this.$store.commit('snackbar', response.data.data || 'Ошибка при сохранении данных')
              }
            })
            .catch(e => {
              this.loader.show = false  
              console.log(e)
              this.$store.commit('snackbar', 'Ошибка при сохранении данных')
            })
        } else {
          this.loader.show = true  
          this.$axios.post('/api/common/insurance/save/', this.form)
            .then(response => {
              this.loader.show = false  
              if (!response.data.error) {
                this.$store.commit('snackbar', 'Успешно')
                this.view = true, this.change = false
                //this.show ? this.$emit('close', response.data.data) : this.$router.push('/insurance/list')
              } else {
                this.$store.commit('snackbar', response.data.data || 'Ошибка при сохранении данных')
              }
            })
            .catch(e => {
              this.loader.show = false  
              console.log(e)
              this.$store.commit('snackbar', 'Ошибка при сохранении данных')
            })
        }
      },
    },
  }
</script>
